import {
	ActivateDeviceRequest,
	ArchiveMembersRequest,
	ArchiveMembersResponse,
	ArchiveOrganizationRadioChannelRequest,
	ArchiveOrganizationRadioChannelResponse,
	ArchiveWorkspaceRequest,
	AssignDeviceRequest,
	AssignDeviceResponse,
	BatchActivateDevicesRequest,
	BatchDisableDevicesRequest,
	BatchSuspendDevicesRequest,
	BulkToggleWorkspaceRadioChannelsRequest,
	BulkToggleWorkspaceRadioChannelsResponse,
	ChangelogServiceClient,
	ClaimOrganizationRequest,
	ConfirmOrganizationClaimCodeRequest,
	ConfirmOrganizationClaimCodeResponse,
	CoordinateDto,
	CreateBeamAuthRequest,
	CreateConversationRequest,
	CreateConversationResponse,
	CreateHealthActivity,
	CreateHealthActivityRequest,
	CreateHealthActivityResponse,
	CreateOrganizationIntegrationRequest,
	CreateOrganizationIntegrationResponse,
	CreateOrganizationRadioChannelRequest,
	CreateOrganizationRadioChannelResponse,
	CreateOrganizationResourceRequest,
	CreateOrganizationResourceResponse,
	CreateOrganizationTakServerRequest,
	CreateOrganizationWorkspaceRequest,
	CreateOrganizationWorkspaceResponse,
	CreateResourceAccountRequest,
	CreateResourceAccountResponse,
	CreateShapeRequest,
	CreateShapeResponse,
	CreateTrackingLocationsRequest,
	CreateWaypoint,
	CreateWaypointRequest,
	CreateWorkspaceKeyApiRequest,
	CreateWorkspaceKeyApiResponse,
	CreateWorkspaceRadioChannelRequest,
	CreateWorkspaceRadioChannelResponse,
	DeleteConversationRequest,
	DeleteConversationResponse,
	DeleteRouteRequest,
	DeleteShapeRequest,
	DeleteShapeResponse,
	DeleteWorkspaceRequest,
	DeviceClient,
	DeviceEventResponseList,
	DeviceList,
	DeviceSettings,
	DeviceSettingsRequest,
	DeviceSettingsRequestList,
	DeviceSettingsResponse,
	DeviceSummaryResponseList,
	DisableDeviceRequest,
	ExportGpxRequest,
	ExportGpxResponse,
	FeatureServiceClient,
	FileServiceClient,
	GetActiveSessionEventsRequest,
	GetActiveSessionEventsResponse,
	GetAssetsRequest,
	GetAssetsResponse,
	GetChangelogRequest,
	GetChangelogResponse,
	GetConversationsRequest,
	GetConversationsResponse,
	GetDefaultSettingsResponse,
	GetDevicesResponse,
	GetDevicesSummaryRequest,
	GetDeviceUsageResponse,
	GetFeaturesRequest,
	GetFeaturesResponse,
	GetFileMetadataRequest,
	GetFileMetadataResponse,
	GetIdentityDevicesRequest,
	GetLastKnownRoutesRequest,
	GetLiveRoutesRequest,
	GetLocationsRequest,
	GetLocationsResponse,
	GetMeshTrafficKeyHistoryRequest,
	GetMeshTrafficKeyHistoryResponse,
	GetMessagesRequest,
	GetNotificationStreamRequest,
	GetOrganizationBillingInfoRequest,
	GetOrganizationBillingInfoResponse,
	GetOrganizationCapabilitiesRequest,
	GetOrganizationCapabilitiesResponse,
	GetOrganizationDataUsageForDevicesRequest,
	GetOrganizationDataUsageForDevicesResponse,
	GetOrganizationDevicesRequest,
	GetOrganizationDevicesResponse,
	GetOrganizationDeviceUsageRequest,
	GetOrganizationIdentitiesRequest,
	GetOrganizationIdentitiesResponse,
	GetOrganizationIntegrationAccountsRequest,
	GetOrganizationIntegrationAccountsResponse,
	GetOrganizationIntegrationsRequest,
	GetOrganizationIntegrationsResponse,
	GetOrganizationLicenseSummaryRequest,
	GetOrganizationLicenseSummaryResponse,
	GetOrganizationMembersRequest,
	GetOrganizationMembersResponse,
	GetOrganizationRadioChannelsRequest,
	GetOrganizationRadioChannelsResponse,
	GetOrganizationsRequest,
	GetOrganizationsResponse,
	GetOrganizationWorkspacesRequest,
	GetOrganizationWorkspacesResponse,
	GetRecentHealthActivityRequest,
	GetRouteLocationsRequest,
	GetRouteLocationsResponse,
	GetRoutesRequest,
	GetRoutesResponse,
	GetSelfAccountsRequest,
	GetSensorsRequest,
	GetSensorsResponse,
	GetShapesRequest,
	GetShapesResponse,
	GetSingleFileUrlRequest,
	GetSingleFileUrlResponse,
	GetUploadUrlRequest,
	GetUploadUrlResponse,
	GetWaypointsRequest,
	GetWaypointsResponse,
	GetWorkspaceDevicesRequest,
	GetWorkspaceMessagesRequest,
	GetWorkspacesRequest,
	GetWorkspacesResponse,
	HealthActivityClient,
	HealthActivityResponseList,
	IdentityRecord,
	InviteMembersRequest,
	InviteMembersResponse,
	InviteOrganizationMembersRequest,
	InviteOrganizationMembersResponse,
	IssueWorkspaceInviteTokenRequest,
	IssueWorkspaceInviteTokenResponse,
	JoinOrganizationWorkspaceRequest,
	JoinWorkspaceByInviteRequest,
	JoinWorkspaceByInviteResponse,
	JoinWorkspaceRequest,
	LeaveWorkspaceRequest,
	LocationResponse,
	LocationResponseList,
	MeshKeyRotationSchedule,
	MessageRequest,
	MessageResponseList,
	MessagingClient,
	NotificationClient,
	NotificationPayload,
	OrganizationClient,
	OrganizationRecord,
	RadioChannel,
	RadioChannelServiceClient,
	RemoveMembersResponse,
	RemoveOrganizationIntegrationRequest,
	RemoveOrganizationIntegrationResponse,
	RemoveOrganizationMembersRequest,
	RemoveOrganizationMembersResponse,
	RouteResponse,
	SendCotToTakServerRequest,
	SendCotToTakServerResponse,
	SendMessageRequest,
	SendMessageResponse,
	SendPingRequest,
	SendSosMessageRequest,
	SensorServiceClient,
	Shape,
	ShapeServiceClient,
	SignInResponse,
	SkipScheduledTrafficKeyRotationResponse,
	SosClient,
	SosEventResponse,
	SosMessageDto,
	StyleSettings,
	SuspendDeviceRequest,
	SystemClient,
	Timestamp,
	ToggleWorkspaceIntegrationRequest,
	TrackingClient,
	TrackingLocationDto,
	TriggerTrafficKeyRotationRequest,
	TriggerTrafficKeyRotationResponse,
	UnassignDeviceRequest,
	UnassignDeviceResponse,
	UpdateOrganizationIntegrationRoutingRequest,
	UpdateOrganizationMemberPasswordRequest,
	UpdateOrganizationMemberPasswordResponse,
	UpdateOrganizationRoleRequest,
	UpdateOrganizationRoleResponse,
	UpdateScheduledTrafficKeyRotationResponse,
	UpdateShapeRequest,
	UpdateShapeResponse,
	UpdateStyleSettingsRequest,
	UpdateUserPasswordRequest,
	UpdateUserPasswordResponse,
	UpdateWorkspaceAccessResponse,
	UpdateWorkspaceAccount,
	UpdateWorkspaceAccountList,
	UpdateWorkspaceAccountsResponse,
	UpdateWorkspaceRoleRequest,
	UpdateWorkspaceRoleResponse,
	UserClient,
	UserIdentityResponse,
	UserResponse,
	WorkspaceClient,
	WorkspaceResponse,
	WorkspaceResponseList,
} from "@somewear/api";
import type {
	CreateOrganizationApiClientResponse,
	DeleteOrganizationApiClientResponse,
	GetDefaultOrganizationSettingsResponse,
	GetOrganizationApiClientsResponse,
	GetOrganizationIntegrationResponse,
	UpdateDefaultOrganizationSettingsResponse,
} from "@somewear/api/src/proto/api/organization_pb";
import {
	CreateOrganizationApiClientRequest,
	DeleteOrganizationApiClientRequest,
	GetDefaultOrganizationSettingsRequest,
	GetOrganizationApiClientsRequest,
	GetOrganizationIntegrationRequest,
	UpdateDefaultOrganizationSettingsRequest,
} from "@somewear/api/src/proto/api/organization_pb";
import type {
	GetWorkspaceRoutesRequest,
	GetWorkspaceRoutesResponse,
} from "@somewear/api/src/proto/api/tracking_pb";
import { RefreshAccessTokenRequest, RenameAssetRequest } from "@somewear/api/src/proto/api/user_pb";
import {
	GetDefaultSettingsRequest,
	RemoveMembersRequest,
	SkipScheduledTrafficKeyRotationRequest,
	UpdateDefaultSettingsRequest,
	UpdateScheduledTrafficKeyRotationRequest,
} from "@somewear/api/src/proto/api/workspace_pb";
import { RadioDataRateParameters } from "@somewear/api/src/proto/command_public_proto_pb";
import { OrganizationDefaultSettings } from "@somewear/api/src/proto/organization_default_settings_proto_pb";
import { WorkspaceDefaultSettings } from "@somewear/api/src/proto/workspace_default_settings_proto_pb";
import type { UpdatePasswordArgs } from "@somewear/auth";
import type {
	CreateHealthActivityForm,
	CreateIntegrationRequest,
	DownloadFileRequestPayload,
	GetWorkspaceFilesRequestPayload,
	IConfig,
	IntegrationConfig,
	IOrganizationAsset,
	IQueuedDeviceActivationChange,
	ISaveWaypointPayload,
	ITrackingRouteWithContact,
	MessageRequestWithState,
	MessageRequestWithStateAndTmpId,
	MessagesRequestPayload,
	SendSosMessageDto,
	SingleWorkspaceIntegrationConfig,
	UploadFileRequest,
} from "@somewear/model";
import {
	DeviceActivationChange,
	isFederatedTakServerIntegrationRequest,
	isSitxBridgeAdapterIntegrationRequest,
	isWebhookIntegrationRequest,
	mapToEnableIntegration,
	mapToEnableIntegrationAccounts,
	mapToUpdateTakResourceAssignedWorkspaces,
	toOptionalBool,
} from "@somewear/model";
import type { OrganizationWorkspaceDefaultsRequestSchema } from "@somewear/organization";
import { OrganizationRadioChannelRequest, WorkspaceRadioChannelRequest } from "@somewear/radio";
import type { WorkspaceDefaultsRequestSchema } from "@somewear/workspace";
import sha256 from "crypto-js/sha256";
import type { ClientReadableStream, Metadata } from "grpc-web";
import moment from "moment";
import { firstValueFrom, forkJoin, from, of } from "rxjs";
import { map, mergeMap, toArray } from "rxjs/operators";

import type { IGrpcRequestHandler, IGrpcRequestHandlerWithPayload } from "./GrpcClient";
import { StreamData, StreamManager } from "./GrpcClient";
// eslint-disable-next-line import/namespace
import * as Mappers from "./somewearGrpcMappers";
// eslint-disable-next-line
const mappers = Mappers;

export const degreeMinuteDtoFromDecimalCoordinate = (coordinate: number): number => {
	const degrees = Math.trunc(coordinate);
	const minutes = (coordinate - degrees) * 60;
	const degMin = degrees * 100.0 + minutes;
	return Math.round(degMin * 10000.0);
};

export const getGrpcDomain = (config: IConfig) => {
	return config.somewear.gRPCDomain !== "auto"
		? config.somewear.gRPCDomain
		: window.location.origin;
};

class Clients {
	private static _instance: Clients;

	changelog: ChangelogServiceClient;
	user: UserClient;
	file: FileServiceClient;
	messaging: MessagingClient;
	health: HealthActivityClient;
	sos: SosClient;
	workspace: WorkspaceClient;
	organization: OrganizationClient;
	tracking: TrackingClient;
	notification: NotificationClient;
	device: DeviceClient;
	featureService: FeatureServiceClient;
	sensorService: SensorServiceClient;
	radioChannelService: RadioChannelServiceClient;
	shape: ShapeServiceClient;
	system: SystemClient;

	static get user() {
		return this._instance.user;
	}

	static get changelog() {
		return this._instance.changelog;
	}

	static get file() {
		return this._instance.file;
	}

	static get messaging() {
		return this._instance.messaging;
	}

	static get health() {
		return this._instance.health;
	}

	static get sos() {
		return this._instance.sos;
	}

	static get workspace() {
		return this._instance.workspace;
	}

	static get organization() {
		return this._instance.organization;
	}

	static get tracking() {
		return this._instance.tracking;
	}

	static get notification() {
		return this._instance.notification;
	}

	static get device() {
		return this._instance.device;
	}

	static get featureService() {
		return this._instance.featureService;
	}

	static get sensorService() {
		return this._instance.sensorService;
	}

	static get shape() {
		return this._instance.shape;
	}

	static get system() {
		return this._instance.system;
	}

	static get radioChannelService() {
		return this._instance.radioChannelService;
	}

	static init(config: IConfig) {
		this._instance = new Clients(config);
	}

	private constructor(config: IConfig) {
		const domain = getGrpcDomain(config);

		this.user = new UserClient(domain);
		this.file = new FileServiceClient(domain);
		this.messaging = new MessagingClient(domain);
		this.health = new HealthActivityClient(domain);
		this.sos = new SosClient(domain);
		this.workspace = new WorkspaceClient(domain);
		this.organization = new OrganizationClient(domain);
		this.tracking = new TrackingClient(domain);
		this.notification = new NotificationClient(domain);
		this.device = new DeviceClient(domain);
		this.featureService = new FeatureServiceClient(domain);
		this.sensorService = new SensorServiceClient(domain);
		this.shape = new ShapeServiceClient(domain);
		this.system = new SystemClient(domain);
		this.changelog = new ChangelogServiceClient(domain);
		this.radioChannelService = new RadioChannelServiceClient(domain);
	}
}

namespace SomewearGrpc {
	export const init = (config: IConfig) => {
		Clients.init(config);
	};

	export const refreshAccessToken: IGrpcRequestHandlerWithPayload<string, SignInResponse> = (
		metadata,
		payload,
	) => {
		const request = new RefreshAccessTokenRequest();
		request.setRefreshToken(payload);
		return Clients.user.refreshAccessToken(request, metadata);
	};

	export const sendPing: IGrpcRequestHandlerWithPayload<Timestamp.AsObject, SendPingRequest> = (
		metadata,
		payload,
	) => {
		const timestamp = new Timestamp();
		timestamp.setSeconds(payload.seconds);
		const request = new SendPingRequest();
		request.setPingTimestamp(timestamp);
		return Clients.system.sendPing(request, metadata);
	};

	export const getHealthActivity: IGrpcRequestHandler<HealthActivityResponseList> = (
		metadata,
	) => {
		return Clients.health.getRecentHealthActivity(
			new GetRecentHealthActivityRequest(),
			metadata,
		);
	};

	export const createHealthActivity: IGrpcRequestHandlerWithPayload<
		CreateHealthActivityForm,
		CreateHealthActivityResponse
	> = (metadata, payload) => {
		const request = new CreateHealthActivityRequest();
		const activity = new CreateHealthActivity();

		activity.setBreathingRate(payload.breathingRate);
		activity.setBreathingRateConfidence(payload.breathingRateConfidence);
		activity.setCoreTemperature(payload.coreTemperature);
		activity.setHeartRate(payload.heartRate);
		activity.setHeartRateConfidence(payload.heartRateConfidence);
		activity.setPosture(payload.posture);
		activity.setPostureValid(payload.posture > 0);
		activity.setTimestamp(moment().unix());
		request.setActivity(activity);

		return Clients.health.createNewHealthActivity(request, metadata);
	};

	export const updateUserPassword: IGrpcRequestHandlerWithPayload<
		UpdatePasswordArgs,
		UpdateUserPasswordResponse
	> = (metadata, payload) => {
		const request = new UpdateUserPasswordRequest();
		request.setNewPassword(payload.newPassword);
		return Clients.user.updateUserPassword(request, metadata);
	};

	export const getWorkspaces: IGrpcRequestHandler<GetWorkspacesResponse> = (metadata) => {
		return Clients.user.getWorkspaces(new GetWorkspacesRequest(), metadata);
	};

	export const getSelfAccounts = (metadata: Metadata) => {
		return Clients.user.getSelfAccounts(new GetSelfAccountsRequest(), metadata);
	};

	/*export const getWorkspaceAccounts: IGrpcRequestHandler<UserResponseList> = (metadata) => {
		const request = new GetWorkspaceAccountsRequest();
		request.setIncludeSelf(true);

		return Clients.user.getWorkspaceAccounts(request, metadata);
	};*/

	export const getWorkspaceDevices: IGrpcRequestHandler<DeviceList> = (metadata) => {
		const request = new GetWorkspaceDevicesRequest();
		return Clients.user.getWorkspaceDevices(request, metadata);
	};

	export const fetchAllWorkspaces: IGrpcRequestHandler<WorkspaceResponseList> = (metadata) => {
		const request = new GetWorkspacesRequest();
		return Clients.workspace.getWorkspaces(request, metadata);
	};

	export const getActiveSosEvents: IGrpcRequestHandler<GetActiveSessionEventsResponse> = (
		metadata,
	) => {
		return Clients.sos.getActiveSessionEvents(new GetActiveSessionEventsRequest(), metadata);
	};

	export const generateAdditionalWorkspaceKey: IGrpcRequestHandler<
		CreateWorkspaceKeyApiResponse
	> = (metadata) => {
		return Clients.workspace.createWorkspaceKey(new CreateWorkspaceKeyApiRequest(), metadata);
	};

	export const generateWorkspaceToken: IGrpcRequestHandlerWithPayload<
		string,
		IssueWorkspaceInviteTokenResponse
	> = (metadata, payload) => {
		const request = new IssueWorkspaceInviteTokenRequest();
		request.setWorkspaceId(payload);
		return Clients.workspace.issueWorkspaceInviteToken(request, metadata);
	};

	export const fetchOrganizations: IGrpcRequestHandler<GetOrganizationsResponse> = (metadata) => {
		return Clients.user.getOrganizations(new GetOrganizationsRequest(), metadata);
	};

	export const fetchOrganizationLicenseSummary: IGrpcRequestHandler<
		GetOrganizationLicenseSummaryResponse
	> = (metadata) => {
		return Clients.organization.getLicenseSummary(
			new GetOrganizationLicenseSummaryRequest(),
			metadata,
		);
	};

	export const updateOrganizationDefaultSettings: IGrpcRequestHandlerWithPayload<
		OrganizationWorkspaceDefaultsRequestSchema,
		UpdateDefaultOrganizationSettingsResponse
	> = (metadata, payload) => {
		const settings = new OrganizationDefaultSettings();
		settings.setTrackingOn(payload.trackingOn);
		settings.setEnableAltitudeReporting(payload.altitude);
		settings.setLowBandwidthTrackingMultiplier(payload.lowBandwidthTrackingMultiplier);
		settings.setEnableBackhaul(payload.backhaul);

		settings.setLedDisabled(payload.ledDisabled);
		settings.setHapticsDisabled(payload.hapticsDisabled);
		settings.setSatDisabled(payload.satDisabled);

		settings.setRadioMode(payload.radioMode);

		if (payload.inmarsatRxFrequencyHz) {
			settings.setInmarsatRxFrequencyHz(payload.inmarsatRxFrequencyHz);
		}

		if (payload.inmarsatTxFrequencyHz) {
			settings.setInmarsatTxFrequencyHz(payload.inmarsatTxFrequencyHz);
		}

		if (payload.inmarsatLeaseType) {
			settings.setInmarsatLeaseType(payload.inmarsatLeaseType);
		}

		settings.setEnableSpeedAndCourseReporting(payload.speedAndCourse);
		settings.setLowSpeedFrequencyHz(payload.lowSpeedFrequency);
		settings.setHighSpeedFrequencyHz(payload.highSpeedFrequency);
		settings.setTrackingInterval(payload.trackingInterval);
		settings.setGpsInterval(payload.gpsInterval);

		if (payload.buttonFunction !== undefined) {
			settings.setButtonFunction(payload.buttonFunction);
		}

		const radioDataRateParameters = new RadioDataRateParameters();
		radioDataRateParameters.setBandwidth(payload.lowSpeedBandwidth);
		radioDataRateParameters.setSpreadFactor(payload.lowSpeedSpreadFactor);
		settings.setLowSpeedDataRateParameters(radioDataRateParameters);

		const highSpeedDataRateParameters = new RadioDataRateParameters();

		if (payload.highSpeedBandwidth) {
			highSpeedDataRateParameters.setBandwidth(payload.highSpeedBandwidth);
		}

		if (payload.highSpeedSpreadFactor) {
			highSpeedDataRateParameters.setSpreadFactor(payload.highSpeedSpreadFactor);
		}

		settings.setHighSpeedDataRateParameters(highSpeedDataRateParameters);
		settings.setMeshKeyMethodVersion(payload.meshKeyMethodVersion);

		const request = new UpdateDefaultOrganizationSettingsRequest();
		request.setOrganizationId(payload.organizationId);
		request.setSettings(settings);

		return Clients.organization.updateDefaultSettings(request, metadata);
	};

	export const getOrganizationDefaultSettings: IGrpcRequestHandlerWithPayload<
		GetDefaultOrganizationSettingsRequest.AsObject,
		GetDefaultOrganizationSettingsResponse
	> = (metadata, payload) => {
		const request = new GetDefaultOrganizationSettingsRequest();
		request.setOrganizationId(payload.organizationId);

		return Clients.organization.getDefaultSettings(request, metadata);
	};

	export const fetchOrganizationMembers: IGrpcRequestHandler<GetOrganizationMembersResponse> = (
		metadata,
	) => {
		return Clients.organization.getMembers(new GetOrganizationMembersRequest(), metadata);
	};

	export const fetchOrganizationIntegration: IGrpcRequestHandlerWithPayload<
		GetOrganizationIntegrationRequest.AsObject,
		GetOrganizationIntegrationResponse
	> = (metadata, payload) => {
		const request = new GetOrganizationIntegrationRequest();
		request.setIdentityId(payload.identityId);

		return Clients.organization.getIntegration(request, metadata);
	};

	export const fetchOrganizationIntegrations: IGrpcRequestHandler<
		GetOrganizationIntegrationsResponse
	> = (metadata) => {
		return Clients.organization.getIntegrations(
			new GetOrganizationIntegrationsRequest(),
			metadata,
		);
	};

	export const fetchChangelogs: IGrpcRequestHandlerWithPayload<
		GetChangelogRequest.AsObject,
		GetChangelogResponse
	> = (metadata, payload) => {
		const request = new GetChangelogRequest();
		request.setPlatformsList(payload.platformsList);

		if (payload.from) {
			const fromTimestamp = new Timestamp();
			fromTimestamp.setSeconds(payload.from.seconds);
			request.setFrom(fromTimestamp);
		}

		if (payload.to) {
			const toTimestamp = new Timestamp();
			toTimestamp.setSeconds(payload.to.seconds);
			request.setTo(toTimestamp);
		}

		const response = Clients.changelog.getChangelog(request, metadata);
		console.warn({ response });
		return response;
	};

	export const createOrganizationWorkspace: IGrpcRequestHandlerWithPayload<
		CreateOrganizationWorkspaceRequest.AsObject,
		CreateOrganizationWorkspaceResponse
	> = (metadata, payload) => {
		const request = new CreateOrganizationWorkspaceRequest();
		request.setName(payload.name);
		request.setAddSelfAsMember(payload.addSelfAsMember);
		request.setMeshKeyMethodVersion(payload.meshKeyMethodVersion);

		if (payload.styleSettings !== undefined) {
			const styleSettings = new StyleSettings();
			styleSettings.setStandardColor(payload.styleSettings.standardColor);
			request.setStyleSettings(styleSettings);
		}

		return Clients.organization.createWorkspace(request, metadata);
	};

	export const createOrganizationIntegration: IGrpcRequestHandlerWithPayload<
		CreateIntegrationRequest,
		CreateOrganizationIntegrationRequest
	> = (metadata, payload) => {
		const request = new CreateOrganizationIntegrationRequest();
		if (isFederatedTakServerIntegrationRequest(payload)) {
			// throw Error("Unable to create TAK integration via this endpoint at this time");
			request.assignFederatedTakIntegration(payload);
		} else if (isWebhookIntegrationRequest(payload)) {
			request.assignWebhookIntegration(payload);
		} else if (isSitxBridgeAdapterIntegrationRequest(payload)) {
			request.assignSitxBridgeAdapterIntegration(payload);
		}

		return Clients.organization.createIntegration(request, metadata);
	};

	export const createOrganizationTakIntegration: IGrpcRequestHandlerWithPayload<
		CreateOrganizationTakServerRequest.AsObject,
		CreateOrganizationIntegrationResponse
	> = (metadata, payload) => {
		const request = new CreateOrganizationTakServerRequest();
		request.setName(payload.name);
		request.setHost(payload.host);
		request.setPort(payload.port);
		request.setClientCert(payload.clientCert);
		request.setClientCertPassword(payload.clientCertPassword);
		request.setServerCert(payload.serverCert);
		request.setServerCertPassword(payload.serverCertPassword);
		if (payload.beamAuth !== undefined) {
			const beamAuth = new CreateBeamAuthRequest();
			beamAuth.setUsername(payload.beamAuth.username);
			beamAuth.setPassword(payload.beamAuth.password);
			request.setBeamAuth(beamAuth);
		}
		return Clients.organization.createTakIntegration(request, metadata);
	};

	export const removeOrganizationIntegration: IGrpcRequestHandlerWithPayload<
		string,
		RemoveOrganizationIntegrationResponse
	> = (metadata, payload) => {
		const request = new RemoveOrganizationIntegrationRequest();
		request.setIdentityId(payload);
		return Clients.organization.removeIntegration(request, metadata);
	};

	export const createOrganizationResource: IGrpcRequestHandlerWithPayload<
		string,
		CreateOrganizationResourceResponse
	> = (metadata, payload) => {
		const request = new CreateOrganizationResourceRequest();
		request.setName(payload);
		return Clients.organization.createResource(request, metadata);
	};

	export const fetchOrganizationWorkspaces: IGrpcRequestHandler<
		GetOrganizationWorkspacesResponse
	> = (metadata) => {
		return Clients.organization.getWorkspaces(new GetOrganizationWorkspacesRequest(), metadata);
	};

	export const fetchOrganizationDevices: IGrpcRequestHandler<GetOrganizationDevicesResponse> = (
		metadata,
	) => {
		const request = new GetOrganizationDevicesRequest();
		request.setIncludeDevicePlans(true);
		return Clients.organization.getDevices(request, metadata);
	};

	export const fetchOrganizationIdentities: IGrpcRequestHandler<
		GetOrganizationIdentitiesResponse
	> = (metadata) => {
		return Clients.organization.getIdentities(new GetOrganizationIdentitiesRequest(), metadata);
	};

	export const fetchOrganizationDeviceUsage: IGrpcRequestHandlerWithPayload<
		string,
		GetDeviceUsageResponse
	> = (metadata, serial) => {
		const request = new GetOrganizationDeviceUsageRequest();
		request.setSerial(serial);
		return Clients.organization.getDeviceUsage(request, metadata);
	};

	export const getOrganizationApiKeys: IGrpcRequestHandler<GetOrganizationApiClientsResponse> = (
		metadata,
	) => {
		const request = new GetOrganizationApiClientsRequest();

		return Clients.organization.getOrganizationApiClients(request, metadata);
	};

	export const createOrganizationApiKey: IGrpcRequestHandlerWithPayload<
		Partial<CreateOrganizationApiClientRequest.AsObject>,
		CreateOrganizationApiClientResponse
	> = (metadata, payload) => {
		const request = new CreateOrganizationApiClientRequest();

		if (payload.name) {
			request.setName(payload.name);
		}

		if (payload.role) {
			request.setRole(payload.role);
		}

		return Clients.organization.createOrganizationApiClient(request, metadata);
	};

	export const deleteOrganizationApiKey: IGrpcRequestHandlerWithPayload<
		DeleteOrganizationApiClientRequest.AsObject,
		DeleteOrganizationApiClientResponse
	> = (metadata, payload) => {
		const request = new DeleteOrganizationApiClientRequest();
		request.setApiClientId(payload.apiClientId);

		return Clients.organization.deleteOrganizationApiClient(request, metadata);
	};

	export const fetchAllDeviceUsageByOrganization: IGrpcRequestHandler<
		GetOrganizationDataUsageForDevicesResponse
	> = (metadata) => {
		return Clients.organization.getDataUsageForDevices(
			new GetOrganizationDataUsageForDevicesRequest(),
			metadata,
		);
	};

	export const fetchOrganizationBillingInfo: IGrpcRequestHandler<
		GetOrganizationBillingInfoResponse
	> = (metadata) => {
		return Clients.organization.getOrganizationBillingInfo(
			new GetOrganizationBillingInfoRequest(),
			metadata,
		);
	};

	export const updateOrganizationAssetPassword: IGrpcRequestHandlerWithPayload<
		UpdateOrganizationMemberPasswordRequest.AsObject,
		UpdateOrganizationMemberPasswordResponse
	> = (metadata, payload) => {
		const request = new UpdateOrganizationMemberPasswordRequest();
		request.setIdentityId(payload.identityId);
		request.setNewPassword(payload.newPassword);

		return Clients.organization.updateMemberPassword(request, metadata);
	};

	export const unassignDevice: IGrpcRequestHandlerWithPayload<string, UnassignDeviceResponse> = (
		metadata,
		serial,
	) => {
		const request = new UnassignDeviceRequest();
		request.setSerial(serial!);
		return Clients.workspace.unassignDevice(request, metadata);
	};

	export const getLocations: IGrpcRequestHandlerWithPayload<
		GetLocationsRequest,
		GetLocationsResponse
	> = (metadata, request) => {
		return Clients.tracking.getLocations(request, metadata);
	};

	/**
	 * @deprecated Use getMessages going forward
	 */
	export const getWorkspaceMessages: IGrpcRequestHandlerWithPayload<
		MessagesRequestPayload,
		MessageResponseList
	> = (metadata, payload) => {
		const request = new GetWorkspaceMessagesRequest();
		if (payload?.before) {
			const timestamp = new Timestamp();
			timestamp.setSeconds(payload.before.seconds);
			timestamp.setNanos(payload.before.nanos);
			request.setBefore(timestamp);
		}

		return Clients.messaging.getWorkspaceMessages(request, metadata);
	};

	export const getMessages: IGrpcRequestHandlerWithPayload<
		MessagesRequestPayload,
		MessageResponseList
	> = (metadata, payload) => {
		const request = new GetMessagesRequest();
		if (payload.conversationInfo.workspaceId?.isNotEmpty()) {
			request.setWorkspaceId(payload.conversationInfo.workspaceId);
		}
		if (payload.conversationInfo.conversationId?.isNotEmpty()) {
			request.setConversationId(payload.conversationInfo.conversationId);
		}
		if (payload?.before) {
			const timestamp = new Timestamp();
			timestamp.setSeconds(payload.before.seconds);
			timestamp.setNanos(payload.before.nanos);
			request.setBefore(timestamp);
		}

		return Clients.messaging.getMessages(request, metadata);
	};

	export const fetchConversations: IGrpcRequestHandler<GetConversationsResponse> = (metadata) => {
		return Clients.messaging.getConversations(new GetConversationsRequest(), metadata);
	};

	export const assignOrganizationRole: IGrpcRequestHandlerWithPayload<
		UpdateOrganizationRoleRequest.AsObject,
		UpdateOrganizationRoleResponse
	> = (metadata, update) => {
		const request = new UpdateOrganizationRoleRequest();
		request.setIdentityId(update.identityId);
		request.setRole(update.role);
		return Clients.organization.updateOrganizationRole(request, metadata);
	};

	export const assignWorkspaceRole: IGrpcRequestHandlerWithPayload<
		UpdateWorkspaceRoleRequest.AsObject,
		UpdateWorkspaceRoleResponse
	> = (metadata, update) => {
		const request = new UpdateWorkspaceRoleRequest();
		request.setUserId(update.userId);
		request.setRole(update.role);
		return Clients.workspace.updateWorkspaceRole(request, metadata);
	};

	export const createResourceAccount: IGrpcRequestHandlerWithPayload<
		string,
		CreateResourceAccountResponse
	> = (metadata, payload) => {
		const request = new CreateResourceAccountRequest();
		request.setName(payload);
		return Clients.workspace.createResourceAccount(request, metadata);
	};

	export const assignDevice: IGrpcRequestHandlerWithPayload<
		AssignDeviceRequest.AsObject,
		AssignDeviceResponse
	> = (metadata, payload) => {
		const request = new AssignDeviceRequest();
		request.setSerial(payload.serial);
		request.setTargetWorkspaceId(payload.targetWorkspaceId);
		request.setTargetIdentityId(payload.targetIdentityId);
		return Clients.workspace.assignDevice(request, metadata);
	};

	export const removeWorkspaceMembers: IGrpcRequestHandlerWithPayload<
		string[],
		RemoveMembersResponse
	> = (metadata, payload) => {
		const request = new RemoveMembersRequest();
		request.setUserIdsList(payload);
		return Clients.workspace.removeMembers(request, metadata);
	};

	export const archiveWorkspaceMembers: IGrpcRequestHandlerWithPayload<
		string[],
		ArchiveMembersResponse
	> = (metadata, payload) => {
		const request = new ArchiveMembersRequest();
		request.setUserIdsList(payload);
		return Clients.workspace.archiveMembers(request, metadata);
	};

	export const addWorkspaceMembers: IGrpcRequestHandlerWithPayload<
		InviteMembersRequest.AsObject,
		InviteMembersResponse
	> = (metadata, payload) => {
		const request = new InviteMembersRequest();
		request.setEmailsList(payload.emailsList);
		request.setIdentityIdsList(payload.identityIdsList);
		request.setInviteToOrganization(payload.inviteToOrganization);
		request.setUsernamesList(payload.usernamesList);
		return Clients.workspace.inviteMembers(request, metadata);
	};

	export const unaryAssignDevice: IGrpcRequestHandlerWithPayload<
		AssignDeviceRequest.AsObject,
		AssignDeviceResponse
	> = (metadata, payload) => {
		const requestObject = payload;
		const request = new AssignDeviceRequest();
		request.setSerial(requestObject.serial);
		request.setTargetWorkspaceId(requestObject.targetWorkspaceId);
		request.setTargetIdentityId(requestObject.targetIdentityId);

		return Clients.device.assignDevice(request, metadata);
	};

	export const bulkAssignDevice: IGrpcRequestHandlerWithPayload<
		AssignDeviceRequest[],
		AssignDeviceResponse.AsObject[]
	> = (metadata, payload) => {
		return firstValueFrom(
			from(payload).pipe(
				mergeMap((request) => {
					return Clients.device.assignDevice(request, metadata);
				}),
				map((it) => it.toObject()),
				toArray(),
			),
		);
	};

	export const updateWorkspaceUser: IGrpcRequestHandlerWithPayload<
		UpdateWorkspaceAccount.AsObject,
		UpdateWorkspaceAccountsResponse
	> = (metadata, payload) => {
		const request = new UpdateWorkspaceAccountList();
		const update = new UpdateWorkspaceAccount();
		update.setId(payload.id);
		update.setFullName(payload.fullName);
		request.addUpdates(update);
		return Clients.user.updateWorkspaceAccounts(request, metadata);
	};

	export const updateWorkspaceUsers: IGrpcRequestHandlerWithPayload<
		UpdateWorkspaceAccountList,
		UpdateWorkspaceAccountsResponse
	> = (metadata, payload) => {
		return Clients.user.updateWorkspaceAccounts(payload, metadata);
	};

	export const joinWorkspaceByKey: IGrpcRequestHandlerWithPayload<
		JoinWorkspaceRequest,
		WorkspaceResponse
	> = (metadata, payload) => {
		return Clients.user.joinWorkspace(payload, metadata);
	};

	export const joinWorkspaceByToken: IGrpcRequestHandlerWithPayload<
		string,
		JoinWorkspaceByInviteResponse
	> = (metadata, payload) => {
		const request = new JoinWorkspaceByInviteRequest();
		request.setToken(payload);
		return Clients.workspace.joinWorkspaceByInvite(request, metadata);
	};

	export const getWorkspaceDefaultSettings: IGrpcRequestHandlerWithPayload<
		GetDefaultSettingsRequest.AsObject,
		GetDefaultSettingsResponse
	> = (metadata, payload) => {
		const request = new GetDefaultSettingsRequest();
		request.setWorkspaceId(payload.workspaceId);

		return Clients.workspace.getDefaultSettings(request, metadata);
	};

	export const updateWorkspaceDefaultSettings: IGrpcRequestHandlerWithPayload<
		WorkspaceDefaultsRequestSchema,
		GetDefaultSettingsResponse
	> = (metadata, payload) => {
		const settings = new WorkspaceDefaultSettings();

		settings.setTrackingOn(payload.trackingOn);
		settings.setTrackingInterval(payload.trackingInterval);
		settings.setLowBandwidthTrackingMultiplier(payload.lowBandwidthTrackingMultiplier);
		settings.setEnableAltitudeReporting(payload.altitude);
		settings.setEnableSpeedAndCourseReporting(payload.speedAndCourse);

		settings.setLedDisabled(payload.ledDisabled);
		settings.setHapticsDisabled(payload.hapticsDisabled);
		settings.setSatDisabled(payload.satDisabled);

		if (payload.buttonFunction !== undefined) {
			settings.setButtonFunction(payload.buttonFunction);
		}

		settings.setEnableBackhaul(payload.backhaul);
		settings.setRadioMode(payload.radioMode);
		settings.setLowSpeedFrequencyHz(payload.lowSpeedFrequency);
		settings.setHighSpeedFrequencyHz(payload.highSpeedFrequency);

		if (payload.meshKeyMethodVersion !== undefined) {
			settings.setMeshKeyMethodVersion(payload.meshKeyMethodVersion);
		}

		settings.setGpsInterval(payload.gpsInterval);

		if (payload.inmarsatRxFrequencyHz) {
			settings.setInmarsatRxFrequencyHz(payload.inmarsatRxFrequencyHz);
		}

		if (payload.inmarsatTxFrequencyHz) {
			settings.setInmarsatTxFrequencyHz(payload.inmarsatTxFrequencyHz);
		}

		if (payload.inmarsatLeaseType) {
			settings.setInmarsatLeaseType(payload.inmarsatLeaseType);
		}

		const lowSpeedRadioDataRateParameters = new RadioDataRateParameters();
		lowSpeedRadioDataRateParameters.setBandwidth(payload.lowSpeedBandwidth);
		lowSpeedRadioDataRateParameters.setSpreadFactor(payload.lowSpeedSpreadFactor);
		settings.setLowSpeedDataRateParameters(lowSpeedRadioDataRateParameters);

		const highSpeedDataRateParameters = new RadioDataRateParameters();

		if (payload.highSpeedBandwidth) {
			highSpeedDataRateParameters.setBandwidth(payload.highSpeedBandwidth);
		}

		if (payload.highSpeedSpreadFactor) {
			highSpeedDataRateParameters.setSpreadFactor(payload.highSpeedSpreadFactor);
		}

		settings.setHighSpeedDataRateParameters(highSpeedDataRateParameters);

		const request = new UpdateDefaultSettingsRequest();
		request.setWorkspaceId(payload.workspaceId);
		request.setSettings(settings);

		return Clients.workspace.updateDefaultSettings(request, metadata);
	};

	// MESSAGES

	export const createConversation: IGrpcRequestHandlerWithPayload<
		CreateConversationRequest.AsObject,
		CreateConversationResponse
	> = (metadata, payload) => {
		const cRequest = new CreateConversationRequest();
		cRequest.setTargetUserId(payload.targetUserId);

		const identity = new IdentityRecord();
		if (payload.target?.email !== undefined) identity.setEmail(payload.target.email);
		if (payload.target?.phoneNumber !== undefined)
			identity.setPhoneNumber(payload.target.phoneNumber);
		cRequest.setTarget(identity);

		const mRequest = new MessageRequest();
		if (payload.message?.content !== undefined && payload.message?.timestamp !== undefined) {
			const timestamp = new Timestamp();
			timestamp.setSeconds(payload.message.timestamp.seconds);
			mRequest.setTimestamp(timestamp);
			mRequest.setContent(payload.message.content);
			cRequest.setMessage(mRequest);
		}
		return Clients.messaging.createConversation(cRequest, metadata);
	};

	export const deleteConversation: IGrpcRequestHandlerWithPayload<
		string,
		DeleteConversationResponse
	> = (metadata, payload) => {
		const request = new DeleteConversationRequest();
		request.setConversationId(payload);
		return Clients.messaging.deleteConversation(request, metadata);
	};

	const createMessageRequest = (message: MessageRequestWithState): MessageRequest => {
		const messageRequest = new MessageRequest();
		messageRequest.setContent(message.content);
		messageRequest.setOutgoing(true);
		messageRequest.setConversationId(message.conversationId);
		messageRequest.setWorkspaceId(message.workspaceId);
		return messageRequest;
	};

	export const sendMessage: IGrpcRequestHandlerWithPayload<
		MessageRequestWithStateAndTmpId,
		SendMessageResponse
	> = (metadata, payload) => {
		const request = new SendMessageRequest();
		request.setMessage(createMessageRequest(payload));
		return Clients.messaging.sendMessage(request, metadata);
	};

	export const uploadFile: IGrpcRequestHandlerWithPayload<
		UploadFileRequest,
		GetUploadUrlResponse
	> = (metadata, payload) => {
		const request = new GetUploadUrlRequest();

		request.setMimeType(payload.file.type);
		request.setName(payload.file.name);
		request.setWorkspaceId(payload.workspaceId);
		request.setHashSha256(sha256(payload.file.name).toString());
		request.setFileSize(payload.file.size);

		return Clients.file.getUploadUrl(request, metadata);
	};

	export const downloadFile: IGrpcRequestHandlerWithPayload<
		DownloadFileRequestPayload,
		GetSingleFileUrlResponse
	> = (metadata, payload) => {
		const request = new GetSingleFileUrlRequest();
		request.setFileId(payload.fileId);
		request.setWorkspaceId(payload.workspaceId);

		return Clients.file.getSingleFileUrl(request, metadata);
	};

	export const getWorkspaceFiles: IGrpcRequestHandlerWithPayload<
		GetWorkspaceFilesRequestPayload,
		GetFileMetadataResponse
	> = (metadata, payload) => {
		const request = new GetFileMetadataRequest();
		request.setWorkspaceId(payload.workspaceId);

		return Clients.file.getFiles(request, metadata);
	};

	// WAYPOINTS
	export const fetchWaypoints: IGrpcRequestHandler<GetWaypointsResponse> = (metadata) => {
		return Clients.tracking.getWaypoints(new GetWaypointsRequest(), metadata);
	};

	// DEVICES
	export const fetchDevices: IGrpcRequestHandler<GetDevicesResponse> = (metadata) => {
		return Clients.device.getDevices(new GetIdentityDevicesRequest(), metadata);
	};

	// ASSETS
	export const fetchAssets: IGrpcRequestHandler<GetAssetsResponse> = (metadata) => {
		const request = new GetAssetsRequest();
		request.setIncludeArchived(true);
		return Clients.user.getAssets(request, metadata);
	};

	export const bulkRenameAssets: IGrpcRequestHandlerWithPayload<
		RenameAssetRequest.AsObject[],
		RenameAssetRequest.AsObject[]
	> = (metadata, payload) => {
		return firstValueFrom(
			from(payload).pipe(
				mergeMap((payload) => {
					return renameAsset(metadata, payload);
				}),
				map((it) => it.toObject()),
				toArray(),
			),
		);
	};

	export const renameAsset: IGrpcRequestHandlerWithPayload<
		RenameAssetRequest.AsObject,
		RenameAssetRequest
	> = (metadata, payload) => {
		const request = new RenameAssetRequest();
		request.setIdentityId(payload.identityId);
		request.setFullName(payload.fullName);
		return Clients.user.renameAsset(request, metadata);
	};

	// CAPABILITY
	export const fetchFeatures: IGrpcRequestHandler<GetFeaturesResponse> = (metadata) => {
		return Clients.featureService.getFeatures(new GetFeaturesRequest(), metadata);
	};

	export const fetchCapabilities: IGrpcRequestHandler<GetOrganizationCapabilitiesResponse> = (
		metadata,
	) => {
		return Clients.featureService.getOrganizationCapabilities(
			new GetOrganizationCapabilitiesRequest(),
			metadata,
		);
	};

	// ROUTES
	export const getLiveRoutes: IGrpcRequestHandler<GetRoutesResponse> = (metadata) => {
		return Clients.tracking.getLiveRoutes(new GetLiveRoutesRequest(), metadata);
	};

	export const getLastKnownRoutes: IGrpcRequestHandler<GetRoutesResponse> = (metadata) => {
		return Clients.tracking.getLastKnownRoutes(new GetLastKnownRoutesRequest(), metadata);
	};

	export const getRoutes: IGrpcRequestHandlerWithPayload<GetRoutesRequest, GetRoutesResponse> = (
		metadata,
		payload,
	) => {
		return Clients.tracking.getRoutes(payload, metadata);
	};

	export const getWorkspaceRoutes: IGrpcRequestHandlerWithPayload<
		GetWorkspaceRoutesRequest,
		GetWorkspaceRoutesResponse
	> = (metadata, payload) => {
		return Clients.tracking.getWorkspaceRoutes(payload, metadata);
	};

	export const fetchDevicesSummary: IGrpcRequestHandler<DeviceSummaryResponseList> = (
		metadata,
	) => {
		return Clients.device.getDevicesSummary(new GetDevicesSummaryRequest(), metadata);
	};

	export const submitDeviceSettings: IGrpcRequestHandlerWithPayload<
		DeviceSettingsResponse.AsObject[],
		DeviceEventResponseList
	> = (metadata, payload) => {
		const requestList = new DeviceSettingsRequestList();
		const requests = payload.mapNotNull((update) => {
			if (update.settings === undefined) return undefined;
			const request = new DeviceSettingsRequest();

			request.setSerial(update.serial);
			const settings = new DeviceSettings();
			settings.setTrackingInterval(update.settings.trackingInterval);
			settings.setGpsInterval(update.settings.gpsInterval);

			if (update.settings.lowBandwidthTrackingMultiplier !== undefined) {
				settings.setLowBandwidthTrackingMultiplier(
					update.settings.lowBandwidthTrackingMultiplier,
				);
			}
			settings.setBatteryReporting(update.settings.batteryReporting);
			settings.setEnableAltitudeReporting(update.settings.enableAltitudeReporting);
			settings.setAltitudeReportingOptional(
				toOptionalBool(update.settings.enableAltitudeReporting),
			);
			settings.setEnableBackhaul(update.settings.enableBackhaul);
			settings.setButtonFunction(update.settings.buttonFunction);
			settings.setEnableSpeedAndCourseReporting(
				update.settings.enableSpeedAndCourseReporting,
			);
			settings.setSentTimestamp(moment().unix());
			settings.setTrackingOn(true);
			settings.setTrackingOnOptional(toOptionalBool(true));
			request.setSettings(settings);
			return request;
		});
		requestList.setRequestsList(requests);
		return Clients.device.updateDevicesSettings(requestList, metadata);
	};

	export const applyQueuedDeviceActivationChanges: IGrpcRequestHandlerWithPayload<
		IQueuedDeviceActivationChange[],
		string[]
	> = (metadata, payload) => {
		return firstValueFrom(
			of(payload).pipe(
				// split the queued activations and suspensions into separate arrays
				map((it) => {
					return {
						activations: it.filter(
							(it) => it.change === DeviceActivationChange.ACTIVATE,
						),
						disables: it.filter((it) => it.change === DeviceActivationChange.DISABLE),
						suspensions: it.filter(
							(it) => it.change === DeviceActivationChange.SUSPEND,
						),
					};
				}),
				// construct request protos for activations and suspensions
				map((it) => {
					return {
						activationRequests: it.activations.map((it) => {
							const request = new ActivateDeviceRequest();
							request.setCurrentState(it.currentState);
							request.setSerial(it.serial);
							return request;
						}),
						suspensionRequests: it.suspensions.map((it) => {
							const request = new SuspendDeviceRequest();
							request.setCurrentState(it.currentState);
							request.setSerial(it.serial);
							return request;
						}),
						disableRequests: it.disables.map((it) => {
							const request = new DisableDeviceRequest();
							request.setSerial(it.serial);
							request.setCurrentState(it.currentState);
							return request;
						}),
					};
				}),
				map((it) => {
					const activationRequest = new BatchActivateDevicesRequest();
					activationRequest.setRequestsList(it.activationRequests);

					const suspensionRequest = new BatchSuspendDevicesRequest();
					suspensionRequest.setRequestsList(it.suspensionRequests);

					const disableRequest = new BatchDisableDevicesRequest();
					disableRequest.setRequestsList(it.disableRequests);

					return {
						activationRequest: activationRequest,
						suspensionRequest: suspensionRequest,
						disableRequest: disableRequest,
					};
				}),
				// make the bulk activation and suspension requests
				mergeMap((it) =>
					forkJoin({
						activations: Clients.device.batchActivateDevices(
							it.activationRequest,
							metadata,
						),
						suspensions: Clients.device.batchSuspendDevices(
							it.suspensionRequest,
							metadata,
						),
						disables: Clients.device.batchDisableDevices(it.disableRequest, metadata),
					}),
				),
				// merge the results into a single array of serials
				map((it) => {
					return it.activations
						.toObject()
						.serialsList.concat(it.suspensions.toObject().serialsList);
				}),
			),
		);
	};

	export const suspendDevice: IGrpcRequestHandlerWithPayload<
		IQueuedDeviceActivationChange,
		string
	> = (metadata, payload) => {
		return firstValueFrom(
			of(payload).pipe(
				mergeMap((payload) => {
					const request = new SuspendDeviceRequest();
					request.setCurrentState(payload.currentState);
					request.setSerial(payload.serial);

					const batchRequest = new BatchSuspendDevicesRequest();
					batchRequest.setRequestsList([request]);
					return Clients.device.batchSuspendDevices(batchRequest, metadata);
				}),
				map((it) => it.toObject().serialsList.first()),
			),
		);
	};

	export const getRouteLocations: IGrpcRequestHandlerWithPayload<
		string[],
		GetRouteLocationsResponse
	> = (metadata, payload) => {
		const request = new GetRouteLocationsRequest();
		request.setRouteIdsList(payload);
		return Clients.tracking.getRouteLocations(request, metadata);
	};

	export const getOrganizationRadioChannels: IGrpcRequestHandler<
		GetOrganizationRadioChannelsResponse
	> = (metadata) => {
		const request = new GetOrganizationRadioChannelsRequest();
		return Clients.radioChannelService.getOrganizationRadioChannels(request, metadata);
	};

	export const createOrganizationRadioChannel: IGrpcRequestHandlerWithPayload<
		OrganizationRadioChannelRequest,
		CreateOrganizationRadioChannelResponse
	> = (metadata, payload) => {
		const request = new CreateOrganizationRadioChannelRequest();

		if (payload.radioChannel) {
			const radioChannel = new RadioChannel();
			radioChannel.setName(payload.radioChannel.name);
			radioChannel.setLowSpeedFrequencyHz(payload.radioChannel.lowSpeedFrequencyHz);
			radioChannel.setHighSpeedFrequencyHz(payload.radioChannel.highSpeedFrequencyHz);

			if (payload.radioChannel.lowSpeedDataRateParameters?.spreadFactor) {
				const lowSpeedDataRateParameters = new RadioDataRateParameters();
				lowSpeedDataRateParameters.setSpreadFactor(
					payload.radioChannel.lowSpeedDataRateParameters.spreadFactor,
				);
				radioChannel.setLowSpeedDataRateParameters(lowSpeedDataRateParameters);
			}

			request.setRadioChannel(radioChannel);
		}
		return Clients.radioChannelService.createOrganizationRadioChannel(request, metadata);
	};

	export const archiveOrganizationRadioChannel: IGrpcRequestHandlerWithPayload<
		ArchiveOrganizationRadioChannelRequest.AsObject,
		ArchiveOrganizationRadioChannelResponse
	> = (metadata, payload) => {
		const request = new ArchiveOrganizationRadioChannelRequest();
		request.setOrganizationRadioChannelId(payload.organizationRadioChannelId);
		return Clients.radioChannelService.archiveOrganizationRadioChannel(request, metadata);
	};

	export const createWorkspaceRadioChannel: IGrpcRequestHandlerWithPayload<
		WorkspaceRadioChannelRequest,
		CreateWorkspaceRadioChannelResponse
	> = (metadata, payload) => {
		const request = new CreateWorkspaceRadioChannelRequest();
		request.setWorkspaceId(payload.workspaceId);

		if (payload.radioChannel) {
			const radioChannel = new RadioChannel();
			radioChannel.setName(payload.radioChannel.name);
			radioChannel.setLowSpeedFrequencyHz(payload.radioChannel.lowSpeedFrequencyHz);
			radioChannel.setHighSpeedFrequencyHz(payload.radioChannel.highSpeedFrequencyHz);

			if (payload.radioChannel.lowSpeedDataRateParameters?.spreadFactor) {
				const lowSpeedDataRateParameters = new RadioDataRateParameters();
				lowSpeedDataRateParameters.setSpreadFactor(
					payload.radioChannel.lowSpeedDataRateParameters?.spreadFactor,
				);
				radioChannel.setLowSpeedDataRateParameters(lowSpeedDataRateParameters);
			}

			request.setRadioChannel(radioChannel);
		}
		return Clients.radioChannelService.createWorkspaceRadioChannel(request, metadata);
	};

	export const bulkToggleWorkspaceRadioChannels: IGrpcRequestHandlerWithPayload<
		BulkToggleWorkspaceRadioChannelsRequest.AsObject,
		BulkToggleWorkspaceRadioChannelsResponse
	> = (metadata, payload) => {
		const request = new BulkToggleWorkspaceRadioChannelsRequest();
		request.setWorkspaceId(payload.workspaceId);
		request.setToggleConfigsList(
			payload.toggleConfigsList.map((config) => {
				const toggleConfig =
					new BulkToggleWorkspaceRadioChannelsRequest.RadioChannelToggleConfig();
				toggleConfig.setRadioChannelId(config.radioChannelId);
				toggleConfig.setEnable(config.enable);
				return toggleConfig;
			}),
		);

		return Clients.radioChannelService.bulkToggleWorkspaceRadioChannels(request, metadata);
	};

	export const joinOrganizationWorkspace: IGrpcRequestHandlerWithPayload<
		string,
		InviteMembersResponse
	> = (metadata, payload) => {
		const request = new JoinOrganizationWorkspaceRequest();
		request.setId(payload);
		return Clients.organization.joinOrganizationWorkspace(request, metadata);
	};

	export const leaveWorkspace: IGrpcRequestHandlerWithPayload<string, ArchiveMembersResponse> = (
		metadata,
		payload,
	) => {
		const request = new LeaveWorkspaceRequest();
		request.setId(payload);
		return Clients.workspace.leaveWorkspace(request, metadata);
	};

	export const configureIntegration: IGrpcRequestHandlerWithPayload<
		IntegrationConfig | SingleWorkspaceIntegrationConfig,
		GetOrganizationIntegrationAccountsResponse
	> = (metadata, payload) => {
		const request = new UpdateOrganizationIntegrationRoutingRequest();
		request.setEnableIntegration(mapToEnableIntegration(payload));
		request.setResourceWorkspaceMappingChangesList(
			mapToUpdateTakResourceAssignedWorkspaces(payload),
		);
		request.setEnableWorkspaceIntegrationsList(mapToEnableIntegrationAccounts(payload));
		console.warn({ request: request.toObject() });
		return Clients.organization.updateIntegrationRouting(request, metadata);
	};

	export const sendCotToTakServer: IGrpcRequestHandlerWithPayload<
		{ identityId: string; cot: string },
		SendCotToTakServerResponse
	> = (metadata, payload) => {
		const request = new SendCotToTakServerRequest();

		request.setIdentityId(payload.identityId);
		request.setCot(payload.cot);
		return Clients.organization.sendCotToTakServer(request, metadata);
	};

	export const bulkToggleIntegrations: IGrpcRequestHandlerWithPayload<
		ToggleWorkspaceIntegrationRequest.AsObject[],
		UserResponse.AsObject[]
	> = (metadata, payload) => {
		return firstValueFrom(
			from(payload).pipe(
				mergeMap((payload) => {
					return toggleIntegration(metadata, payload);
				}),
				map((it) => it.toObject()),
				toArray(),
			),
		);
	};

	export const toggleIntegration: IGrpcRequestHandlerWithPayload<
		ToggleWorkspaceIntegrationRequest.AsObject,
		UserResponse
	> = (metadata, payload) => {
		const request = new ToggleWorkspaceIntegrationRequest();
		request.setIdentityId(payload.identityId);
		request.setWorkspaceId(payload.workspaceId);
		request.setEnableIntegration(payload.enableIntegration);
		console.log({ request: request.toObject() });
		return Clients.workspace.toggleWorkspaceIntegration(request, metadata);
	};

	export const fetchIntegrationAccounts: IGrpcRequestHandler<
		GetOrganizationIntegrationAccountsResponse
	> = (metadata) => {
		return Clients.organization.getIntegrationAccounts(
			new GetOrganizationIntegrationAccountsRequest(),
			metadata,
		);
	};

	export const archiveOrganizationWorkspace: IGrpcRequestHandlerWithPayload<
		string,
		UpdateWorkspaceAccessResponse
	> = (metadata, payload) => {
		const request = new ArchiveWorkspaceRequest();
		request.setId(payload);
		return Clients.workspace.archiveWorkspace(request, metadata);
	};

	export const deleteOrganizationWorkspace: IGrpcRequestHandlerWithPayload<
		string,
		UpdateWorkspaceAccessResponse
	> = (metadata, payload) => {
		const request = new DeleteWorkspaceRequest();
		request.setId(payload);
		return Clients.workspace.deleteWorkspace(request, metadata);
	};

	export const addOrganizationMembers: IGrpcRequestHandlerWithPayload<
		IdentityRecord.AsObject[],
		InviteOrganizationMembersResponse
	> = (metadata, payload) => {
		const request = new InviteOrganizationMembersRequest();
		request.setIdentityRecordsList(
			payload.mapNotNull((item) => {
				const record = new IdentityRecord();
				record.setEmail(item.email ?? "");
				record.setUsername(item.username ?? "");
				record.setId(item.id ?? "");
				record.setOrganizationId(item.organizationId ?? "");
				return record;
			}),
		);
		return Clients.organization.inviteOrganizationMembers(request, metadata);
	};

	export const removeOrganizationMembers: IGrpcRequestHandlerWithPayload<
		IOrganizationAsset[],
		RemoveOrganizationMembersResponse
	> = (metadata, payload) => {
		const request = new RemoveOrganizationMembersRequest();
		request.setIdentityRecordsList(
			payload.mapNotNull((item) => {
				const record = new IdentityRecord();
				record.setId(item.id ?? "");
				return record;
			}),
		);
		return Clients.organization.removeOrganizationMembers(request, metadata);
	};

	const routeResponseFromITrackingRouteWithUser = (
		input: ITrackingRouteWithContact,
	): RouteResponse => {
		const response = new RouteResponse();
		response.setId(input.id);
		response.setName(input.name);
		response.setNotes(input.notes);
		response.setType(input.type);
		const userResponse = new UserResponse();
		userResponse.setId(input.contact.id);
		userResponse.setFullname(input.contact.name);
		response.setOwnerId(input.contact.id);
		response.setOwner(userResponse);
		return response;
	};

	const timestampFromObject = (input: Timestamp.AsObject): Timestamp => {
		const response = new Timestamp();
		response.setSeconds(input.seconds);
		response.setNanos(input.nanos);
		return response;
	};

	const coordinateFromObject = (input: CoordinateDto.AsObject): CoordinateDto => {
		const response = new CoordinateDto();
		response.setLatitude(input.latitude);
		response.setLongitude(input.longitude);
		return response;
	};

	const locationResponseFromObject = (input: LocationResponse.AsObject): LocationResponse => {
		const response = new LocationResponse();
		response.setId(input.id);
		response.setUserId(input.userId);
		response.setAltitude(input.altitude);
		response.setRouteId(input.routeId);
		if (input.coordinate) response.setCoordinate(coordinateFromObject(input.coordinate));
		if (input.timestamp) response.setTimestamp(timestampFromObject(input.timestamp));
		return response;
	};

	export const getSensors: IGrpcRequestHandlerWithPayload<void, GetSensorsResponse> = (
		metadata,
	) => {
		return Clients.sensorService.getSensors(new GetSensorsRequest(), metadata);
	};

	export const downloadRouteLocations: IGrpcRequestHandlerWithPayload<
		{
			routes: ITrackingRouteWithContact[];
			locations: LocationResponse.AsObject[];
		},
		ExportGpxResponse
	> = (metadata, payload) => {
		const request = new ExportGpxRequest();
		request.setRoutesList(
			payload.routes.mapNotNull((route) => routeResponseFromITrackingRouteWithUser(route)),
		);
		request.setLocationsList(
			payload.locations.mapNotNull((location) => locationResponseFromObject(location)),
		);
		return Clients.tracking.exportGpx(request, metadata);
	};

	export const createTrackingLocations: IGrpcRequestHandlerWithPayload<
		GeolocationPosition,
		LocationResponseList
	> = (metadata, payload) => {
		const request = new CreateTrackingLocationsRequest();
		const location = new TrackingLocationDto();
		location.setLatitude(degreeMinuteDtoFromDecimalCoordinate(payload.coords.latitude));
		location.setLongitude(degreeMinuteDtoFromDecimalCoordinate(payload.coords.longitude));
		location.setTimestamp(Math.floor(payload.timestamp / 1000));
		location.setAltitude(payload.coords.altitude ?? 0);
		request.setLocationsList([location]);
		console.log(location.toObject());
		return Clients.tracking.createTrackingLocations(request, metadata);
	};

	export const createWaypoint: IGrpcRequestHandlerWithPayload<
		GeolocationPosition,
		RouteResponse
	> = (metadata, payload) => {
		const request = new CreateWaypointRequest();
		const waypoint = new CreateWaypoint();
		waypoint.setLatitude(degreeMinuteDtoFromDecimalCoordinate(payload.coords.latitude));
		waypoint.setLongitude(degreeMinuteDtoFromDecimalCoordinate(payload.coords.longitude));
		waypoint.setTimestamp(Math.floor(payload.timestamp / 1000));
		waypoint.setName("Waypoint from Web");
		request.setWaypoint(waypoint);

		return Clients.tracking.createWaypoint(request, metadata);
	};

	export const getMostRecentPublicRoute: IGrpcRequestHandlerWithPayload<string, RouteResponse> = (
		metadata,
		payload,
	) => {
		throw Error("unimplemented method");
		/*const request = new GetMostRecentPublicRouteRequest();
		request.setUuid(payload);
		return Clients.tracking.getMostRecentPublicRoute(request, metadata);*/
	};

	export const getPublicRoutes: IGrpcRequestHandlerWithPayload<string, GetRoutesResponse> = (
		metadata,
		payload,
	) => {
		throw Error("unimplemented method");
		/*const request = new GetPublicRoutesRequest();
		request.setUuid(payload);
		return Clients.tracking.getPublicRoutes(request, metadata);*/
	};

	export const getPublicRouteLocations: IGrpcRequestHandlerWithPayload<
		{ uuid: string; routeId: string },
		GetRouteLocationsResponse
	> = (metadata, payload) => {
		throw Error("unimplemented method");
		/*const request = new GetPublicRouteLocationsRequest();
		request.setUuid(payload.uuid);
		const routeRequest = new GetRouteLocationsRequest();
		routeRequest.addRouteIds(payload.routeId);
		request.setRouteRequest(routeRequest);
		return Clients.tracking.getPublicRouteLocations(request, metadata);*/
	};

	export const startSosSession: IGrpcRequestHandlerWithPayload<
		SendSosMessageDto,
		SosEventResponse
	> = (metadata, payload) => {
		const message = new SosMessageDto();
		message.setLatitude(degreeMinuteDtoFromDecimalCoordinate(payload.latitude));
		message.setLongitude(degreeMinuteDtoFromDecimalCoordinate(payload.longitude));

		const now = moment(new Date()).unix();
		message.setTimestamp(now);
		message.setInitialTime(now);

		message.setType(SosMessageDto.SosMessageType.ALARM);
		message.setSandbox(true);
		const request = new SendSosMessageRequest();
		request.setSosMessage(message);
		return Clients.sos.sendSosMessage(request, metadata);
	};

	export const resolveSosSession: IGrpcRequestHandlerWithPayload<void, SosEventResponse> = (
		metadata,
		payload,
	) => {
		const message = new SosMessageDto();
		message.setTimestamp(moment(new Date()).unix());
		message.setType(SosMessageDto.SosMessageType.CANCEL);
		message.setSandbox(true);
		const request = new SendSosMessageRequest();
		request.setSosMessage(message);
		return Clients.sos.sendSosMessage(request, metadata);
	};

	export const saveWaypoint: IGrpcRequestHandlerWithPayload<
		ISaveWaypointPayload,
		RouteResponse
	> = (metadata, payload) => {
		const request = new CreateWaypointRequest();
		const waypoint = new CreateWaypoint();
		waypoint.setLatitude(degreeMinuteDtoFromDecimalCoordinate(payload.location.lat));
		waypoint.setLongitude(degreeMinuteDtoFromDecimalCoordinate(payload.location.lng));
		waypoint.setTimestamp(Math.floor(payload.location.timestamp / 1000));
		waypoint.setName(payload.name);
		if (payload.notes) waypoint.setNotes(payload.notes);

		if (payload.workspaceId !== undefined)
			waypoint.setWorkspaceIdsList([parseInt(payload.workspaceId)]);

		if (payload.cotPackage !== undefined) {
			waypoint.setAffiliation(payload.cotPackage.affiliation);
			waypoint.setDimension(payload.cotPackage.dimension);
			// todo: remove hack to avoid null pointer exception on backend
			if (payload.notes === undefined) waypoint.setNotes("");
		}

		request.setWaypoint(waypoint);

		return Clients.tracking.createWaypoint(request, metadata);
	};

	export const triggerMeshKeyRotationRequest: IGrpcRequestHandlerWithPayload<
		TriggerTrafficKeyRotationRequest.AsObject,
		TriggerTrafficKeyRotationResponse
	> = (metadata, payload) => {
		const request = new TriggerTrafficKeyRotationRequest();
		request.setWorkspaceId(payload.workspaceId);
		return Clients.workspace.triggerTrafficKeyRotation(request, metadata);
	};

	export const updateScheduledTrafficKeyRotationRequest: IGrpcRequestHandlerWithPayload<
		UpdateScheduledTrafficKeyRotationRequest.AsObject,
		UpdateScheduledTrafficKeyRotationResponse
	> = (metadata, payload) => {
		const request = new UpdateScheduledTrafficKeyRotationRequest();
		request.setWorkspaceId(payload.workspaceId);

		if (payload.schedule !== undefined) {
			const schedule = new MeshKeyRotationSchedule();
			schedule.setNextRotationTime(payload.schedule.nextRotationTime);
			schedule.setInterval(payload.schedule.interval);
			schedule.setIntervalUnit(payload.schedule.intervalUnit);
			schedule.setSkippedRotationTime(payload.schedule.skippedRotationTime);
			request.setSchedule(schedule);
		}

		return Clients.workspace.updateScheduledTrafficKeyRotation(request, metadata);
	};

	export const skipScheduledTrafficKeyRotationRequest: IGrpcRequestHandlerWithPayload<
		SkipScheduledTrafficKeyRotationRequest.AsObject,
		SkipScheduledTrafficKeyRotationResponse
	> = (metadata, payload) => {
		const request = new SkipScheduledTrafficKeyRotationRequest();
		request.setWorkspaceId(payload.workspaceId);
		return Clients.workspace.skipScheduledTrafficKeyRotation(request, metadata);
	};

	export const getMeshTrafficKeyHistoryRequest: IGrpcRequestHandlerWithPayload<
		GetMeshTrafficKeyHistoryRequest.AsObject,
		GetMeshTrafficKeyHistoryResponse
	> = (metadata, payload) => {
		const request = new GetMeshTrafficKeyHistoryRequest();
		request.setWorkspaceId(payload.workspaceId);
		request.setLimit(payload.limit ?? 0);

		if (payload.from !== undefined) request.setFrom(timestampFromObject(payload.from));

		return Clients.workspace.getMeshTrafficKeyHistory(request, metadata);
	};

	export const deleteWaypoint: IGrpcRequestHandlerWithPayload<string, DeleteRouteRequest> = (
		metadata,
		payload,
	) => {
		const request = new DeleteRouteRequest();
		request.setRouteId(payload);
		return Clients.tracking.deleteRoute(request, metadata);
	};

	const convertStyleSettingsToProto = (styleSettings: StyleSettings.AsObject): StyleSettings => {
		const style = new StyleSettings();

		if (styleSettings.standardColor !== undefined)
			style.setStandardColor(styleSettings.standardColor);

		if (styleSettings.standardIcon !== undefined)
			style.setStandardIcon(styleSettings.standardIcon);

		if (styleSettings.affiliation !== undefined)
			style.setAffiliation(styleSettings.affiliation);
		if (styleSettings.dimension !== undefined) style.setDimension(styleSettings.dimension);
		return style;
	};

	export const updateIdentityStyle: IGrpcRequestHandlerWithPayload<
		UpdateStyleSettingsRequest.AsObject,
		UserIdentityResponse
	> = (metadata, payload) => {
		const request = new UpdateStyleSettingsRequest();
		request.setEntityId(payload.entityId);
		if (payload.styleSettings !== undefined) {
			const styles = convertStyleSettingsToProto(payload.styleSettings);
			request.setStyleSettings(styles);
		}
		return Clients.user.updateStyle(request, metadata);
	};

	export const updateWorkspaceStyle: IGrpcRequestHandlerWithPayload<
		UpdateStyleSettingsRequest.AsObject,
		WorkspaceResponse
	> = (metadata, payload) => {
		const request = new UpdateStyleSettingsRequest();
		request.setEntityId(payload.entityId);
		if (payload.styleSettings !== undefined) {
			const styles = convertStyleSettingsToProto(payload.styleSettings);
			request.setStyleSettings(styles);
		}
		return Clients.workspace.updateStyle(request, metadata);
	};

	// SHAPES
	export const getShapes: IGrpcRequestHandler<GetShapesResponse.AsObject> = (metadata) => {
		return firstValueFrom(
			of(metadata).pipe(
				mergeMap((metadata) => {
					return Clients.shape.getShapes(new GetShapesRequest(), metadata);
				}),
				map((response) => {
					const responseObject = response.toObject();
					responseObject.shapesList.forEach((shape) => {
						if (shape?.circle !== undefined) {
							shape.circle.radius /= 1000; // convert radius to kms
						}
					});
					return responseObject;
				}),
			),
		);
	};

	export const editShape: IGrpcRequestHandlerWithPayload<Shape.AsObject, UpdateShapeResponse> = (
		metadata,
		payload,
	) => {
		const request = new UpdateShapeRequest();
		request.assignShape(payload);
		return Clients.shape.updateShape(request, metadata);
	};

	export const createShape: IGrpcRequestHandlerWithPayload<
		Shape.AsObject,
		CreateShapeResponse.AsObject
	> = (metadata, payload) => {
		return firstValueFrom(
			of({ payload: payload, metadata: metadata }).pipe(
				mergeMap((input) => {
					const { payload, metadata } = input;
					const request = new CreateShapeRequest();
					request.assignShape(payload);
					return Clients.shape.createShape(request, metadata);
				}),
				map((response) => {
					const responseObject = response.toObject();
					if (responseObject.shape?.circle !== undefined) {
						responseObject.shape.circle.radius /= 1000; // convert radius to kms
					}
					return responseObject;
				}),
			),
		);
	};

	export const deleteShape: IGrpcRequestHandlerWithPayload<string, DeleteShapeResponse> = (
		metadata,
		payload,
	) => {
		const request = new DeleteShapeRequest();
		request.setId(payload);
		return Clients.shape.deleteShape(request, metadata);
	};

	export const confirmOrganizationClaimCode: IGrpcRequestHandlerWithPayload<
		string,
		ConfirmOrganizationClaimCodeResponse
	> = (metadata, payload) => {
		const request = new ConfirmOrganizationClaimCodeRequest();
		request.setOrganizationClaimCode(payload);
		return Clients.organization.confirmClaimCode(request, metadata);
	};

	export const claimOrganization: IGrpcRequestHandlerWithPayload<
		ClaimOrganizationRequest.AsObject,
		OrganizationRecord
	> = (metadata, payload) => {
		const request = new ClaimOrganizationRequest();
		request.setOrganizationClaimCode(payload.organizationClaimCode);
		request.setOrganizationName(payload.organizationName);
		return Clients.organization.claimOrganization(request, metadata);
	};

	// STREAM

	class NotificationStreamManager extends StreamManager<NotificationPayload> {
		constructor() {
			super((metadata) => {
				return new StreamData(
					Clients.notification.getNotificationStream(
						new GetNotificationStreamRequest(),
						metadata,
					) as ClientReadableStream<NotificationPayload>,
				);
			});
		}
	}
	export const notificationStreamManager: NotificationStreamManager =
		new NotificationStreamManager();
}

export { SomewearGrpc as someGrpc };

export default SomewearGrpc;
